export default __webpack_public_path__ + "7542a726690ed427e6fc0ddb6eff5906.jpg";